import { TableHeaders } from "@/models/types";
// информацию - номер и дата договора. Так же электронную почту менеджера.
//"Contract number" },
// { key: "t", label: "Contract date" },
// { key: "h", label: "Manager's email" },
export const headers: TableHeaders[] = [
  { key: "selected", label: "" },
  { key: "index", label: "#" },
  { key: "invoice_id", label: "ИД счета" },
  { key: "date_bill", label: "Дата выставления счета" },
  { key: "contract", label: "Номер и дата договора" },
  { key: "manager_email", label: "Электронная почта менеджера" },
  { key: "pays_spec_account", label: "Оплата со спец. счета" },
  { key: "real_upload_at", label: "Дата реальной выгрузки" },
  { key: "deal_id", label: "ИД сделки" },
  { key: "company_own", label: "Наша компания" },
  { key: "company", label: "Компания клиента" },
  { key: "agreement", label: "Заключен договор?" },
  { key: "kpp", label: "КПП" },
  { key: "inn", label: "ИНН" },
  { key: "sum_paid", label: "Сумма счёта" },
  { key: "form_of_payment", label: "Форма оплаты" },
  { key: "list_uslug", label: "Услуги" },
  { key: "files_invoice", label: "Счёт" },
  { key: "files_act", label: "Акт" },
  { key: "files_account", label: "СЧФ" },
  { key: "files_upd", label: "УДП" },
  { key: "files_other", label: "Иные документы" },
  { key: "defect", label: "Дефект документов" },
  { key: "one_c", label: "Выставлен в 1С" },
  { key: "close", label: "Закрыт" },
];
